import { createFileRoute } from "@tanstack/react-router";
import TermsOfService from "@/pages/TermsOfService";
import { buildBreadcrumbLd } from "@/lib/structured-data";

export const Route = createFileRoute("/_sticky/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service - Gatlinburg Wine Trail" },
      { name: "description", content: "The terms governing your use of the Gatlinburg Wine Trail website and services." },
      { property: "og:title", content: "Terms of Service - Gatlinburg Wine Trail" },
      { property: "og:description", content: "The terms governing your use of the Gatlinburg Wine Trail website and services." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://demo.gatlinburgwinetrail.com/terms" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Terms of Service - Gatlinburg Wine Trail" },
      { name: "twitter:description", content: "The terms governing your use of the Gatlinburg Wine Trail website and services." },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildBreadcrumbLd([{ name: "Terms of Use", path: "/terms" }]),
        ),
      },
    ],
    links: [{ rel: "canonical", href: "https://demo.gatlinburgwinetrail.com/terms" }],
  }),
  component: TermsOfService,
});
